import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './configureStore';
import App from './app/App';
import { configureAmplify } from './app/configureAmplify';
import { SessionProvider } from './context/SessionProvider';
import { ThemeProvider } from './context/ThemeProvider';
import './tailwind.css';

configureAmplify();

const root = createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <BrowserRouter basename="/app">
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
);
